var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagBra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(1851 2973)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_464",
    "data-name": "Ret\\xE2ngulo 464",
    width: 102.851,
    height: 59.993,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_BRA",
    transform: "translate(-1851 -2973)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_brasil",
    transform: "translate(1829.842 2973)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_463",
    "data-name": "Ret\\xE2ngulo 463",
    width: 102.851,
    height: 59.993,
    transform: "translate(0 0)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6716",
    "data-name": "Caminho 6716",
    d: "M9.251,26.959,44.815,49.673,80.4,26.959,44.815,4.249Z",
    transform: "translate(6.61 3.037)",
    fill: "#edc226"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_792",
    "data-name": "Grupo 792",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_791",
    "data-name": "Grupo 791",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6717",
    "data-name": "Caminho 6717",
    d: "M51.233,23.747a14.99,14.99,0,1,1-14.994-15,14.994,14.994,0,0,1,14.994,15",
    transform: "translate(15.186 6.249)",
    fill: "#2d146e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6718",
    "data-name": "Caminho 6718",
    d: "M27.48,13.744a37.5,37.5,0,0,0-5.159.365,15.739,15.739,0,0,0-.8,2.292,35.092,35.092,0,0,1,5.956-.513,34.134,34.134,0,0,1,22.882,8.766,13.738,13.738,0,0,0,.532-2.373A36.241,36.241,0,0,0,27.48,13.744",
    transform: "translate(15.379 9.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6719",
    "data-name": "Caminho 6719",
    d: "M22.837,15.527a.716.716,0,0,0-.175-1.413.658.658,0,0,0-.544.784.667.667,0,0,0,.718.629m-.031-.261a.433.433,0,0,0,.317-.494.409.409,0,0,0-.43-.4.415.415,0,0,0-.324.49.427.427,0,0,0,.437.4",
    transform: "translate(15.798 10.082)",
    fill: "#3c9242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6720",
    "data-name": "Caminho 6720",
    d: "M23.251,15.485l.257-.024-.034-.526.579-.039a.467.467,0,0,0,.413-.482A.46.46,0,0,0,23.988,14l-.826.057Zm.2-.814.55-.036a.192.192,0,0,0,.168-.2.172.172,0,0,0-.185-.168l-.557.031Z",
    transform: "translate(16.55 10.001)",
    fill: "#3c9242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6721",
    "data-name": "Caminho 6721",
    d: "M24.223,15.079c-.012-.2-.036-.65-.346-.634l-.389.027c.442-.027.478.423.5.622",
    transform: "translate(16.782 10.321)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6722",
    "data-name": "Caminho 6722",
    d: "M24.282,15.4l.665-.015a.615.615,0,0,0,.61-.626l-.012-.2a.618.618,0,0,0-.622-.6l-.665.014Zm.252-.273.389-.009a.38.38,0,0,0,.377-.393V14.6a.382.382,0,0,0-.384-.374l-.394.009Z",
    transform: "translate(17.333 9.972)",
    fill: "#3c9242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6723",
    "data-name": "Caminho 6723",
    d: "M25.32,15.385l1.293.045.012-.269-1.036-.036.012-.362.82.021v-.242l-.808-.031v-.281l.988.033v-.269l-1.221-.041Z",
    transform: "translate(18.091 9.969)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6724",
    "data-name": "Caminho 6724",
    d: "M26.384,15.425l.245.021.084-.976.192,1,.233.021.365-.952-.084.976.24.024.125-1.426-.348-.031-.377.952-.2-1L26.5,14Z",
    transform: "translate(18.852 10.004)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6725",
    "data-name": "Caminho 6725",
    d: "M28.105,15.554l1.072.18.029-.24-.808-.137.053-.321.67.113.031-.245-.653-.11.031-.225.79.137.029-.242-1.017-.18Z",
    transform: "translate(20.082 10.208)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6726",
    "data-name": "Caminho 6726",
    d: "M29.69,15.911l.25.069.144-.511.545.137a.456.456,0,0,0,.557-.321.471.471,0,0,0-.324-.55l-.79-.2Zm.466-.706.526.141a.171.171,0,0,0,.216-.132.186.186,0,0,0-.125-.225l-.533-.137Z",
    transform: "translate(21.214 10.383)",
    fill: "#3c9242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6727",
    "data-name": "Caminho 6727",
    d: "M30.713,16.172l.257.077.163-.5.531.171a.453.453,0,0,0,.569-.291.445.445,0,0,0-.288-.562l-.789-.247Zm.5-.679.526.168a.189.189,0,0,0,.228-.123.175.175,0,0,0-.12-.228l-.521-.166Z",
    transform: "translate(21.945 10.589)",
    fill: "#3c9242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6728",
    "data-name": "Caminho 6728",
    d: "M31.576,16.168c.065-.194.2-.619-.089-.712l-.365-.12c.418.137.286.562.221.76",
    transform: "translate(22.237 10.959)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6729",
    "data-name": "Caminho 6729",
    d: "M32.24,16.641a.682.682,0,0,0,.849-.444.646.646,0,1,0-1.2-.458.689.689,0,0,0,.353.9m.089-.252a.413.413,0,0,0,.514-.288.418.418,0,0,0-.19-.554.433.433,0,0,0-.521.291.423.423,0,0,0,.2.55",
    transform: "translate(22.747 10.907)",
    fill: "#3c9242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6730",
    "data-name": "Caminho 6730",
    d: "M33.2,17.029a.717.717,0,0,0,.569-1.31.671.671,0,0,0-.868.4.684.684,0,0,0,.3.912m.108-.245a.407.407,0,0,0,.521-.261.423.423,0,0,0-.163-.566.459.459,0,0,0-.358.826",
    transform: "translate(23.465 11.198)",
    fill: "#3c9242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6731",
    "data-name": "Caminho 6731",
    d: "M33.3,16.1l.5.218-.1.187-.483-.221Z",
    transform: "translate(23.741 11.507)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6732",
    "data-name": "Caminho 6732",
    d: "M33.568,16.18l.192.087-.293.652-.175-.084Z",
    transform: "translate(23.788 11.562)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6733",
    "data-name": "Caminho 6733",
    d: "M33.68,17.271l.233.118.233-.48.509.261a.449.449,0,0,0,.4-.8L34.332,16Zm.586-.592.49.242A.181.181,0,0,0,35,16.84a.186.186,0,0,0-.079-.245l-.5-.245Z",
    transform: "translate(24.065 11.435)",
    fill: "#3c9242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6734",
    "data-name": "Caminho 6734",
    d: "M34.449,17.433c.089-.183.286-.583.017-.722l-.353-.178c.413.206.211.607.127.787",
    transform: "translate(24.375 11.814)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6735",
    "data-name": "Caminho 6735",
    d: "M34.619,17.743l1.125.631.12-.23-.9-.513.173-.319.712.4.12-.221-.706-.394.144-.255.844.485.144-.23-1.078-.605Z",
    transform: "translate(24.736 11.786)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6736",
    "data-name": "Caminho 6736",
    d: "M35.98,17.971c-.077.117,0,.254.168.365s.286.1.341.029c.154-.25-.742-.607-.468-1.032.235-.367.648-.084.8.015a.469.469,0,0,1,.209.65l-.262-.171c.089-.122,0-.25-.149-.329-.132-.1-.24-.134-.317,0-.139.2.753.566.471,1-.185.315-.538.175-.765.031-.211-.129-.5-.429-.312-.725Z",
    transform: "translate(25.465 12.255)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6737",
    "data-name": "Caminho 6737",
    d: "M36.874,18.552c-.089.113-.024.254.144.374s.293.127.346.048c.163-.233-.723-.643-.413-1.053.259-.357.658-.048.8.053a.465.465,0,0,1,.168.662l-.245-.183c.077-.122,0-.249-.139-.346s-.221-.135-.31-.012c-.144.189.712.614.425,1.024-.221.305-.569.149-.778-.012-.2-.137-.478-.449-.269-.739Z",
    transform: "translate(26.102 12.686)",
    fill: "#3c9242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6738",
    "data-name": "Caminho 6738",
    d: "M37.665,19.7a.719.719,0,1,0-.053-.958.679.679,0,0,0,.053.958m.168-.213a.415.415,0,0,0,.581-.113.422.422,0,0,0-.024-.585.4.4,0,0,0-.569.115.4.4,0,0,0,.012.583",
    transform: "translate(26.753 13.185)",
    fill: "#3c9242",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6739",
    "data-name": "Caminho 6739",
    d: "M22.934,15.548l-.2.61.31.1Z",
    transform: "translate(16.246 11.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6740",
    "data-name": "Caminho 6740",
    d: "M22.894,15.548l.2.61-.305.1Z",
    transform: "translate(16.286 11.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6741",
    "data-name": "Caminho 6741",
    d: "M23.474,15.809h-.64v.314Z",
    transform: "translate(16.316 11.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6742",
    "data-name": "Caminho 6742",
    d: "M23.5,15.809l-.509.374-.2-.257Z",
    transform: "translate(16.286 11.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6743",
    "data-name": "Caminho 6743",
    d: "M22.5,15.809l.521.374.19-.257Z",
    transform: "translate(16.074 11.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6744",
    "data-name": "Caminho 6744",
    d: "M22.5,15.809h.646v.314Z",
    transform: "translate(16.074 11.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6745",
    "data-name": "Caminho 6745",
    d: "M23.279,16.48l-.2-.61-.3.1Z",
    transform: "translate(16.278 11.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6746",
    "data-name": "Caminho 6746",
    d: "M23.289,16.492l-.521-.381.192-.259Z",
    transform: "translate(16.268 11.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6747",
    "data-name": "Caminho 6747",
    d: "M22.632,16.492l.521-.381-.187-.259Z",
    transform: "translate(16.171 11.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6748",
    "data-name": "Caminho 6748",
    d: "M22.632,16.48l.2-.61.31.1Z",
    transform: "translate(16.171 11.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6749",
    "data-name": "Caminho 6749",
    d: "M23.715,19.226l-.2.607.312.1Z",
    transform: "translate(16.799 13.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6750",
    "data-name": "Caminho 6750",
    d: "M23.675,19.226l.192.607-.3.1Z",
    transform: "translate(16.839 13.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6751",
    "data-name": "Caminho 6751",
    d: "M24.243,19.484h-.634v.324Z",
    transform: "translate(16.869 13.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6752",
    "data-name": "Caminho 6752",
    d: "M24.271,19.484l-.509.381-.19-.267Z",
    transform: "translate(16.842 13.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6753",
    "data-name": "Caminho 6753",
    d: "M23.274,19.484l.509.381.2-.267Z",
    transform: "translate(16.63 13.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6754",
    "data-name": "Caminho 6754",
    d: "M23.274,19.484h.646v.324Z",
    transform: "translate(16.63 13.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6755",
    "data-name": "Caminho 6755",
    d: "M24.062,20.159l-.2-.61-.312.1Z",
    transform: "translate(16.829 13.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6756",
    "data-name": "Caminho 6756",
    d: "M24.067,20.171l-.521-.382.185-.255Z",
    transform: "translate(16.824 13.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6757",
    "data-name": "Caminho 6757",
    d: "M23.4,20.171l.533-.382-.2-.255Z",
    transform: "translate(16.722 13.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6758",
    "data-name": "Caminho 6758",
    d: "M23.4,20.159l.2-.61.312.1Z",
    transform: "translate(16.722 13.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6759",
    "data-name": "Caminho 6759",
    d: "M22.6,20.134l-.12.413.2.065Z",
    transform: "translate(16.066 14.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6760",
    "data-name": "Caminho 6760",
    d: "M22.582,20.134l.132.413-.2.065Z",
    transform: "translate(16.089 14.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6761",
    "data-name": "Caminho 6761",
    d: "M22.971,20.308h-.43v.216Z",
    transform: "translate(16.106 14.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6762",
    "data-name": "Caminho 6762",
    d: "M22.986,20.308l-.341.254-.125-.173Z",
    transform: "translate(16.091 14.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6763",
    "data-name": "Caminho 6763",
    d: "M22.321,20.308l.341.254.125-.173Z",
    transform: "translate(15.949 14.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6764",
    "data-name": "Caminho 6764",
    d: "M22.321,20.308h.425v.216Z",
    transform: "translate(15.949 14.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6765",
    "data-name": "Caminho 6765",
    d: "M22.839,20.757l-.132-.406-.2.069Z",
    transform: "translate(16.083 14.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6766",
    "data-name": "Caminho 6766",
    d: "M22.843,20.766l-.341-.252.125-.177Z",
    transform: "translate(16.078 14.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6767",
    "data-name": "Caminho 6767",
    d: "M22.411,20.766l.341-.252-.12-.177Z",
    transform: "translate(16.014 14.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6768",
    "data-name": "Caminho 6768",
    d: "M22.411,20.757l.125-.406.2.069Z",
    transform: "translate(16.014 14.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6769",
    "data-name": "Caminho 6769",
    d: "M24.527,18.886l-.1.288.142.053Z",
    transform: "translate(17.453 13.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6770",
    "data-name": "Caminho 6770",
    d: "M24.507,18.886l.089.288-.142.053Z",
    transform: "translate(17.473 13.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6771",
    "data-name": "Caminho 6771",
    d: "M24.777,19.011h-.3v.149Z",
    transform: "translate(17.491 13.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6772",
    "data-name": "Caminho 6772",
    d: "M24.79,19.011l-.245.18-.084-.127Z",
    transform: "translate(17.478 13.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6773",
    "data-name": "Caminho 6773",
    d: "M24.311,19.011l.257.18.084-.127Z",
    transform: "translate(17.371 13.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6774",
    "data-name": "Caminho 6774",
    d: "M24.311,19.011h.312v.149Z",
    transform: "translate(17.371 13.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6775",
    "data-name": "Caminho 6775",
    d: "M24.687,19.334l-.1-.3-.132.051Z",
    transform: "translate(17.473 13.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6776",
    "data-name": "Caminho 6776",
    d: "M24.692,19.339l-.245-.183.089-.125Z",
    transform: "translate(17.468 13.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6777",
    "data-name": "Caminho 6777",
    d: "M24.381,19.339l.245-.183-.089-.125Z",
    transform: "translate(17.42 13.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6778",
    "data-name": "Caminho 6778",
    d: "M24.381,19.334l.089-.3.144.051Z",
    transform: "translate(17.42 13.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6779",
    "data-name": "Caminho 6779",
    d: "M25.522,20.157l-.168.511.24.087Z",
    transform: "translate(18.116 14.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6780",
    "data-name": "Caminho 6780",
    d: "M25.489,20.157l.156.511-.245.087Z",
    transform: "translate(18.149 14.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6781",
    "data-name": "Caminho 6781",
    d: "M25.964,20.375h-.533v.264Z",
    transform: "translate(18.171 14.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6782",
    "data-name": "Caminho 6782",
    d: "M25.986,20.375l-.43.314-.156-.221Z",
    transform: "translate(18.149 14.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6783",
    "data-name": "Caminho 6783",
    d: "M25.152,20.375l.43.314.156-.221Z",
    transform: "translate(17.972 14.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6784",
    "data-name": "Caminho 6784",
    d: "M25.152,20.375h.533v.264Z",
    transform: "translate(17.972 14.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6785",
    "data-name": "Caminho 6785",
    d: "M25.811,20.928l-.168-.5-.257.084Z",
    transform: "translate(18.139 14.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6786",
    "data-name": "Caminho 6786",
    d: "M25.816,20.936l-.437-.31.156-.213Z",
    transform: "translate(18.134 14.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6787",
    "data-name": "Caminho 6787",
    d: "M25.271,20.936l.42-.31-.156-.213Z",
    transform: "translate(18.056 14.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6788",
    "data-name": "Caminho 6788",
    d: "M25.271,20.928l.156-.5.25.084Z",
    transform: "translate(18.056 14.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6789",
    "data-name": "Caminho 6789",
    d: "M25.257,21.026l-.168.511.252.084Z",
    transform: "translate(17.927 15.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6790",
    "data-name": "Caminho 6790",
    d: "M25.224,21.026l.161.511-.25.084Z",
    transform: "translate(17.96 15.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6791",
    "data-name": "Caminho 6791",
    d: "M25.706,21.244h-.533V21.5Z",
    transform: "translate(17.986 15.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6792",
    "data-name": "Caminho 6792",
    d: "M25.731,21.244l-.437.314-.156-.218Z",
    transform: "translate(17.961 15.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6793",
    "data-name": "Caminho 6793",
    d: "M24.894,21.244l.43.314.156-.218Z",
    transform: "translate(17.787 15.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6794",
    "data-name": "Caminho 6794",
    d: "M24.894,21.244h.533V21.5Z",
    transform: "translate(17.787 15.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6795",
    "data-name": "Caminho 6795",
    d: "M25.54,21.8l-.156-.511-.257.082Z",
    transform: "translate(17.954 15.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6796",
    "data-name": "Caminho 6796",
    d: "M25.551,21.812l-.437-.321.168-.209Z",
    transform: "translate(17.944 15.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6797",
    "data-name": "Caminho 6797",
    d: "M25.005,21.812l.43-.321-.154-.209Z",
    transform: "translate(17.867 15.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6798",
    "data-name": "Caminho 6798",
    d: "M25.005,21.8l.161-.511.257.082Z",
    transform: "translate(17.867 15.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6799",
    "data-name": "Caminho 6799",
    d: "M32.788,14.405l-.2.614.31.1Z",
    transform: "translate(23.287 10.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6800",
    "data-name": "Caminho 6800",
    d: "M32.751,14.405l.2.614-.312.1Z",
    transform: "translate(23.324 10.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6801",
    "data-name": "Caminho 6801",
    d: "M33.33,14.663h-.641v.326Z",
    transform: "translate(23.357 10.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6802",
    "data-name": "Caminho 6802",
    d: "M33.357,14.663l-.521.381-.185-.264Z",
    transform: "translate(23.329 10.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6803",
    "data-name": "Caminho 6803",
    d: "M32.35,14.663l.526.381.185-.264Z",
    transform: "translate(23.115 10.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6804",
    "data-name": "Caminho 6804",
    d: "M32.35,14.663H33v.326Z",
    transform: "translate(23.115 10.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6805",
    "data-name": "Caminho 6805",
    d: "M33.139,15.342l-.2-.614-.3.1Z",
    transform: "translate(23.32 10.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6806",
    "data-name": "Caminho 6806",
    d: "M33.149,15.354l-.526-.381.19-.262Z",
    transform: "translate(23.31 10.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6807",
    "data-name": "Caminho 6807",
    d: "M32.486,15.354l.521-.381-.185-.262Z",
    transform: "translate(23.212 10.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6808",
    "data-name": "Caminho 6808",
    d: "M32.486,15.342l.2-.614.31.1Z",
    transform: "translate(23.212 10.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6809",
    "data-name": "Caminho 6809",
    d: "M36.2,20.191l-.2.61.31.1Z",
    transform: "translate(25.727 14.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6810",
    "data-name": "Caminho 6810",
    d: "M36.16,20.191l.2.61-.3.1Z",
    transform: "translate(25.769 14.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6811",
    "data-name": "Caminho 6811",
    d: "M36.749,20.45H36.1v.317Z",
    transform: "translate(25.796 14.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6812",
    "data-name": "Caminho 6812",
    d: "M36.776,20.45l-.514.377-.2-.264Z",
    transform: "translate(25.769 14.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6813",
    "data-name": "Caminho 6813",
    d: "M35.764,20.45l.526.377.185-.264Z",
    transform: "translate(25.554 14.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6814",
    "data-name": "Caminho 6814",
    d: "M35.764,20.45h.646v.317Z",
    transform: "translate(25.554 14.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6815",
    "data-name": "Caminho 6815",
    d: "M36.565,21.123l-.2-.61-.31.1Z",
    transform: "translate(25.759 14.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6816",
    "data-name": "Caminho 6816",
    d: "M36.57,21.136l-.526-.377.19-.264Z",
    transform: "translate(25.754 14.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6817",
    "data-name": "Caminho 6817",
    d: "M35.9,21.136l.521-.377-.192-.264Z",
    transform: "translate(25.654 14.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6818",
    "data-name": "Caminho 6818",
    d: "M35.9,21.123l.2-.61.312.1Z",
    transform: "translate(25.654 14.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6819",
    "data-name": "Caminho 6819",
    d: "M37.4,20.4l-.144.4.216.065Z",
    transform: "translate(26.622 14.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6820",
    "data-name": "Caminho 6820",
    d: "M37.377,20.4l.132.4-.216.065Z",
    transform: "translate(26.647 14.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6821",
    "data-name": "Caminho 6821",
    d: "M37.747,20.572h-.418v.209Z",
    transform: "translate(26.672 14.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6822",
    "data-name": "Caminho 6822",
    d: "M37.767,20.572l-.341.252-.125-.177Z",
    transform: "translate(26.652 14.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6823",
    "data-name": "Caminho 6823",
    d: "M37.1,20.572l.341.252.137-.177Z",
    transform: "translate(26.51 14.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6824",
    "data-name": "Caminho 6824",
    d: "M37.1,20.572h.43v.209Z",
    transform: "translate(26.51 14.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6825",
    "data-name": "Caminho 6825",
    d: "M37.619,21.02l-.12-.41-.209.072Z",
    transform: "translate(26.645 14.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6826",
    "data-name": "Caminho 6826",
    d: "M37.624,21.028l-.341-.252.132-.177Z",
    transform: "translate(26.64 14.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6827",
    "data-name": "Caminho 6827",
    d: "M37.192,21.028l.341-.252-.12-.177Z",
    transform: "translate(26.575 14.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6828",
    "data-name": "Caminho 6828",
    d: "M37.192,21.02l.132-.41.2.072Z",
    transform: "translate(26.575 14.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6829",
    "data-name": "Caminho 6829",
    d: "M36.545,21.026l-.156.511.245.084Z",
    transform: "translate(26.001 15.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6830",
    "data-name": "Caminho 6830",
    d: "M36.512,21.026l.161.511-.238.084Z",
    transform: "translate(26.034 15.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6831",
    "data-name": "Caminho 6831",
    d: "M37,21.244h-.533V21.5Z",
    transform: "translate(26.056 15.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6832",
    "data-name": "Caminho 6832",
    d: "M37.021,21.244l-.418.314-.168-.218Z",
    transform: "translate(26.033 15.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6833",
    "data-name": "Caminho 6833",
    d: "M36.187,21.244l.437.314.154-.218Z",
    transform: "translate(25.856 15.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6834",
    "data-name": "Caminho 6834",
    d: "M36.187,21.244h.533V21.5Z",
    transform: "translate(25.856 15.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6835",
    "data-name": "Caminho 6835",
    d: "M36.839,21.8l-.161-.511-.257.082Z",
    transform: "translate(26.024 15.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6836",
    "data-name": "Caminho 6836",
    d: "M36.844,21.812l-.43-.321.154-.209Z",
    transform: "translate(26.019 15.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6837",
    "data-name": "Caminho 6837",
    d: "M36.3,21.812l.43-.321-.154-.209Z",
    transform: "translate(25.936 15.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6838",
    "data-name": "Caminho 6838",
    d: "M36.3,21.8l.161-.511.257.082Z",
    transform: "translate(25.936 15.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6839",
    "data-name": "Caminho 6839",
    d: "M34.445,22.859l-.168.506.252.086Z",
    transform: "translate(24.492 16.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6840",
    "data-name": "Caminho 6840",
    d: "M34.415,22.859l.161.506-.257.086Z",
    transform: "translate(24.522 16.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6841",
    "data-name": "Caminho 6841",
    d: "M34.894,23.077h-.533v.269Z",
    transform: "translate(24.552 16.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6842",
    "data-name": "Caminho 6842",
    d: "M34.919,23.077l-.437.31-.156-.218Z",
    transform: "translate(24.527 16.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6843",
    "data-name": "Caminho 6843",
    d: "M34.082,23.077l.43.31.144-.218Z",
    transform: "translate(24.352 16.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6844",
    "data-name": "Caminho 6844",
    d: "M34.082,23.077h.533v.269Z",
    transform: "translate(24.352 16.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6845",
    "data-name": "Caminho 6845",
    d: "M34.727,23.636l-.149-.509-.269.081Z",
    transform: "translate(24.515 16.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6846",
    "data-name": "Caminho 6846",
    d: "M34.732,23.645l-.43-.317.154-.213Z",
    transform: "translate(24.51 16.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6847",
    "data-name": "Caminho 6847",
    d: "M34.193,23.645l.43-.317-.154-.213Z",
    transform: "translate(24.432 16.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6848",
    "data-name": "Caminho 6848",
    d: "M34.193,23.636l.161-.509.257.081Z",
    transform: "translate(24.432 16.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6849",
    "data-name": "Caminho 6849",
    d: "M34.413,23.8l-.125.4.2.069Z",
    transform: "translate(24.5 17.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6850",
    "data-name": "Caminho 6850",
    d: "M34.391,23.8l.132.4-.2.069Z",
    transform: "translate(24.522 17.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6851",
    "data-name": "Caminho 6851",
    d: "M34.773,23.977h-.418v.213Z",
    transform: "translate(24.547 17.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6852",
    "data-name": "Caminho 6852",
    d: "M34.8,23.977l-.353.245-.125-.17Z",
    transform: "translate(24.522 17.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6853",
    "data-name": "Caminho 6853",
    d: "M34.127,23.977l.341.245.125-.17Z",
    transform: "translate(24.385 17.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6854",
    "data-name": "Caminho 6854",
    d: "M34.127,23.977h.425v.213Z",
    transform: "translate(24.385 17.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6855",
    "data-name": "Caminho 6855",
    d: "M34.65,24.417l-.132-.4-.209.06Z",
    transform: "translate(24.514 17.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6856",
    "data-name": "Caminho 6856",
    d: "M34.655,24.426l-.353-.245.132-.173Z",
    transform: "translate(24.509 17.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6857",
    "data-name": "Caminho 6857",
    d: "M34.218,24.426l.341-.245-.132-.173Z",
    transform: "translate(24.45 17.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6858",
    "data-name": "Caminho 6858",
    d: "M34.218,24.417l.132-.4.2.06Z",
    transform: "translate(24.45 17.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6859",
    "data-name": "Caminho 6859",
    d: "M35.308,22.23l-.144.41.2.067Z",
    transform: "translate(25.125 15.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6860",
    "data-name": "Caminho 6860",
    d: "M35.28,22.23l.12.41-.2.067Z",
    transform: "translate(25.153 15.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6861",
    "data-name": "Caminho 6861",
    d: "M35.664,22.4h-.437v.216Z",
    transform: "translate(25.17 16.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6862",
    "data-name": "Caminho 6862",
    d: "M35.681,22.4l-.346.257-.132-.17Z",
    transform: "translate(25.153 16.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6863",
    "data-name": "Caminho 6863",
    d: "M35.007,22.4l.348.257.118-.17Z",
    transform: "translate(25.013 16.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6864",
    "data-name": "Caminho 6864",
    d: "M35.007,22.4h.437v.216Z",
    transform: "translate(25.013 16.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6865",
    "data-name": "Caminho 6865",
    d: "M35.53,22.851l-.137-.4-.2.067Z",
    transform: "translate(25.148 16.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6866",
    "data-name": "Caminho 6866",
    d: "M35.535,22.858l-.346-.249.137-.173Z",
    transform: "translate(25.143 16.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6867",
    "data-name": "Caminho 6867",
    d: "M35.1,22.858l.346-.249-.125-.173Z",
    transform: "translate(25.078 16.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6868",
    "data-name": "Caminho 6868",
    d: "M35.1,22.851l.137-.4.2.067Z",
    transform: "translate(25.078 16.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6869",
    "data-name": "Caminho 6869",
    d: "M36.013,21.729l-.161.506.245.084Z",
    transform: "translate(25.617 15.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6870",
    "data-name": "Caminho 6870",
    d: "M35.986,21.729l.168.506-.264.084Z",
    transform: "translate(25.644 15.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6871",
    "data-name": "Caminho 6871",
    d: "M36.461,21.945h-.533v.264Z",
    transform: "translate(25.672 15.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6872",
    "data-name": "Caminho 6872",
    d: "M36.479,21.945l-.42.314-.154-.221Z",
    transform: "translate(25.654 15.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6873",
    "data-name": "Caminho 6873",
    d: "M35.649,21.945l.437.314.154-.221Z",
    transform: "translate(25.472 15.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6874",
    "data-name": "Caminho 6874",
    d: "M35.649,21.945h.533v.264Z",
    transform: "translate(25.472 15.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6875",
    "data-name": "Caminho 6875",
    d: "M36.3,22.5l-.156-.5-.264.082Z",
    transform: "translate(25.639 15.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6876",
    "data-name": "Caminho 6876",
    d: "M36.307,22.509l-.43-.31.154-.216Z",
    transform: "translate(25.635 15.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6877",
    "data-name": "Caminho 6877",
    d: "M35.761,22.509l.442-.31-.168-.216Z",
    transform: "translate(25.552 15.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6878",
    "data-name": "Caminho 6878",
    d: "M35.761,22.5l.173-.5.245.082Z",
    transform: "translate(25.552 15.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6879",
    "data-name": "Caminho 6879",
    d: "M34.383,22.064l-.12.406.2.069Z",
    transform: "translate(24.482 15.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6880",
    "data-name": "Caminho 6880",
    d: "M34.36,22.064l.144.406-.209.069Z",
    transform: "translate(24.505 15.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6881",
    "data-name": "Caminho 6881",
    d: "M34.763,22.239h-.437v.213Z",
    transform: "translate(24.527 15.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6882",
    "data-name": "Caminho 6882",
    d: "M34.78,22.239l-.353.249-.125-.177Z",
    transform: "translate(24.51 15.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6883",
    "data-name": "Caminho 6883",
    d: "M34.1,22.239l.341.249.125-.177Z",
    transform: "translate(24.367 15.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6884",
    "data-name": "Caminho 6884",
    d: "M34.1,22.239h.43v.213Z",
    transform: "translate(24.367 15.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6885",
    "data-name": "Caminho 6885",
    d: "M34.634,22.692l-.137-.413-.209.063Z",
    transform: "translate(24.5 15.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6886",
    "data-name": "Caminho 6886",
    d: "M34.637,22.7l-.353-.261.12-.165Z",
    transform: "translate(24.497 15.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6887",
    "data-name": "Caminho 6887",
    d: "M34.193,22.7l.341-.261-.125-.165Z",
    transform: "translate(24.432 15.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6888",
    "data-name": "Caminho 6888",
    d: "M34.193,22.692l.132-.413.209.063Z",
    transform: "translate(24.432 15.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6889",
    "data-name": "Caminho 6889",
    d: "M26.734,17.54l-.168.506.257.081Z",
    transform: "translate(18.982 12.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6890",
    "data-name": "Caminho 6890",
    d: "M26.7,17.54l.161.506-.25.081Z",
    transform: "translate(19.015 12.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6891",
    "data-name": "Caminho 6891",
    d: "M27.182,17.755h-.533v.266Z",
    transform: "translate(19.042 12.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6892",
    "data-name": "Caminho 6892",
    d: "M27.2,17.755l-.43.321-.156-.221Z",
    transform: "translate(19.019 12.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6893",
    "data-name": "Caminho 6893",
    d: "M26.363,17.755l.437.321.156-.221Z",
    transform: "translate(18.837 12.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6894",
    "data-name": "Caminho 6894",
    d: "M26.363,17.755H26.9v.266Z",
    transform: "translate(18.837 12.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6895",
    "data-name": "Caminho 6895",
    d: "M27.017,18.315l-.156-.506-.257.081Z",
    transform: "translate(19.009 12.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6896",
    "data-name": "Caminho 6896",
    d: "M27.027,18.326l-.437-.314.156-.219Z",
    transform: "translate(18.999 12.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6897",
    "data-name": "Caminho 6897",
    d: "M26.475,18.326l.442-.314-.156-.219Z",
    transform: "translate(18.917 12.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6898",
    "data-name": "Caminho 6898",
    d: "M26.475,18.315l.173-.506.245.081Z",
    transform: "translate(18.917 12.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6899",
    "data-name": "Caminho 6899",
    d: "M32.421,16.8l-.12.41.2.063Z",
    transform: "translate(23.08 12.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6900",
    "data-name": "Caminho 6900",
    d: "M32.4,16.8l.144.41-.209.063Z",
    transform: "translate(23.103 12.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6901",
    "data-name": "Caminho 6901",
    d: "M32.795,16.978h-.43v.209Z",
    transform: "translate(23.125 12.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6902",
    "data-name": "Caminho 6902",
    d: "M32.813,16.978l-.353.252-.12-.175Z",
    transform: "translate(23.107 12.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6903",
    "data-name": "Caminho 6903",
    d: "M32.137,16.978l.348.252.118-.175Z",
    transform: "translate(22.963 12.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6904",
    "data-name": "Caminho 6904",
    d: "M32.137,16.978h.437v.209Z",
    transform: "translate(22.963 12.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6905",
    "data-name": "Caminho 6905",
    d: "M32.667,17.428l-.144-.41-.2.069Z",
    transform: "translate(23.098 12.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6906",
    "data-name": "Caminho 6906",
    d: "M32.672,17.437l-.353-.257.125-.173Z",
    transform: "translate(23.093 12.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6907",
    "data-name": "Caminho 6907",
    d: "M32.228,17.437l.346-.257-.125-.173Z",
    transform: "translate(23.028 12.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6908",
    "data-name": "Caminho 6908",
    d: "M32.228,17.428l.132-.41.2.069Z",
    transform: "translate(23.028 12.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6909",
    "data-name": "Caminho 6909",
    d: "M30.079,21.047l-.2.61.312.1Z",
    transform: "translate(21.346 15.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6910",
    "data-name": "Caminho 6910",
    d: "M30.036,21.047l.2.61-.3.1Z",
    transform: "translate(21.389 15.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6911",
    "data-name": "Caminho 6911",
    d: "M30.614,21.3H29.98v.324Z",
    transform: "translate(21.421 15.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6912",
    "data-name": "Caminho 6912",
    d: "M30.641,21.3l-.514.382-.185-.266Z",
    transform: "translate(21.394 15.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6913",
    "data-name": "Caminho 6913",
    d: "M29.638,21.3l.533.382.173-.266Z",
    transform: "translate(21.177 15.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6914",
    "data-name": "Caminho 6914",
    d: "M29.638,21.3h.641v.324Z",
    transform: "translate(21.177 15.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6915",
    "data-name": "Caminho 6915",
    d: "M30.423,21.979l-.192-.607-.31.1Z",
    transform: "translate(21.379 15.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6916",
    "data-name": "Caminho 6916",
    d: "M30.428,21.992l-.514-.381.178-.257Z",
    transform: "translate(21.374 15.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6917",
    "data-name": "Caminho 6917",
    d: "M29.774,21.992l.521-.381-.192-.257Z",
    transform: "translate(21.274 15.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6918",
    "data-name": "Caminho 6918",
    d: "M29.774,21.979l.2-.607.312.1Z",
    transform: "translate(21.274 15.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6919",
    "data-name": "Caminho 6919",
    d: "M31.08,19.373l-.168.509.257.077Z",
    transform: "translate(22.087 13.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6920",
    "data-name": "Caminho 6920",
    d: "M31.047,19.373l.168.509-.257.077Z",
    transform: "translate(22.12 13.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6921",
    "data-name": "Caminho 6921",
    d: "M31.527,19.589h-.538v.261Z",
    transform: "translate(22.142 13.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6922",
    "data-name": "Caminho 6922",
    d: "M31.549,19.589l-.437.31-.154-.214Z",
    transform: "translate(22.12 13.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6923",
    "data-name": "Caminho 6923",
    d: "M30.713,19.589l.43.31.156-.214Z",
    transform: "translate(21.945 13.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6924",
    "data-name": "Caminho 6924",
    d: "M30.713,19.589h.533v.261Z",
    transform: "translate(21.945 13.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6925",
    "data-name": "Caminho 6925",
    d: "M31.366,20.15l-.168-.511-.25.086Z",
    transform: "translate(22.113 14.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6926",
    "data-name": "Caminho 6926",
    d: "M31.371,20.16l-.43-.317.154-.218Z",
    transform: "translate(22.108 14.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6927",
    "data-name": "Caminho 6927",
    d: "M30.821,20.16l.437-.317-.156-.218Z",
    transform: "translate(22.023 14.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6928",
    "data-name": "Caminho 6928",
    d: "M30.821,20.15l.168-.511.257.086Z",
    transform: "translate(22.023 14.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6929",
    "data-name": "Caminho 6929",
    d: "M30.064,18.589l-.168.5.257.084Z",
    transform: "translate(21.361 13.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6930",
    "data-name": "Caminho 6930",
    d: "M30.026,18.589l.161.5-.238.084Z",
    transform: "translate(21.399 13.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6931",
    "data-name": "Caminho 6931",
    d: "M30.513,18.8h-.533v.269Z",
    transform: "translate(21.421 13.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6932",
    "data-name": "Caminho 6932",
    d: "M30.535,18.8l-.43.31-.156-.211Z",
    transform: "translate(21.399 13.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6933",
    "data-name": "Caminho 6933",
    d: "M29.7,18.8l.437.31.144-.211Z",
    transform: "translate(21.222 13.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6934",
    "data-name": "Caminho 6934",
    d: "M29.7,18.8h.533v.269Z",
    transform: "translate(21.222 13.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6935",
    "data-name": "Caminho 6935",
    d: "M30.353,19.363l-.161-.509-.257.079Z",
    transform: "translate(21.389 13.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6936",
    "data-name": "Caminho 6936",
    d: "M30.358,19.373l-.43-.314.154-.219Z",
    transform: "translate(21.384 13.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6937",
    "data-name": "Caminho 6937",
    d: "M29.812,19.373l.43-.314-.154-.219Z",
    transform: "translate(21.302 13.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6938",
    "data-name": "Caminho 6938",
    d: "M29.812,19.363l.161-.509.259.079Z",
    transform: "translate(21.302 13.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6939",
    "data-name": "Caminho 6939",
    d: "M29.166,19.434l-.132.41.209.065Z",
    transform: "translate(20.745 13.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6940",
    "data-name": "Caminho 6940",
    d: "M29.138,19.434l.144.41-.209.065Z",
    transform: "translate(20.773 13.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6941",
    "data-name": "Caminho 6941",
    d: "M29.529,19.607H29.1v.209Z",
    transform: "translate(20.795 14.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6942",
    "data-name": "Caminho 6942",
    d: "M29.551,19.607l-.346.252-.132-.177Z",
    transform: "translate(20.773 14.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6943",
    "data-name": "Caminho 6943",
    d: "M28.88,19.607l.341.252.12-.177Z",
    transform: "translate(20.636 14.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6944",
    "data-name": "Caminho 6944",
    d: "M28.88,19.607H29.3v.209Z",
    transform: "translate(20.636 14.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6945",
    "data-name": "Caminho 6945",
    d: "M29.4,20.055l-.125-.406-.211.065Z",
    transform: "translate(20.768 14.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6946",
    "data-name": "Caminho 6946",
    d: "M29.4,20.063l-.341-.252.132-.173Z",
    transform: "translate(20.765 14.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6947",
    "data-name": "Caminho 6947",
    d: "M28.971,20.063l.341-.252-.125-.173Z",
    transform: "translate(20.7 14.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6948",
    "data-name": "Caminho 6948",
    d: "M28.971,20.055l.132-.406.2.065Z",
    transform: "translate(20.7 14.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6949",
    "data-name": "Caminho 6949",
    d: "M29.6,20.113l-.1.29.144.045Z",
    transform: "translate(21.08 14.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6950",
    "data-name": "Caminho 6950",
    d: "M29.58,20.113l.089.29-.142.045Z",
    transform: "translate(21.097 14.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6951",
    "data-name": "Caminho 6951",
    d: "M29.852,20.235h-.305v.153Z",
    transform: "translate(21.112 14.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6952",
    "data-name": "Caminho 6952",
    d: "M29.862,20.235l-.24.183-.089-.127Z",
    transform: "translate(21.102 14.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6953",
    "data-name": "Caminho 6953",
    d: "M29.383,20.235l.257.183.091-.127Z",
    transform: "translate(20.995 14.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6954",
    "data-name": "Caminho 6954",
    d: "M29.383,20.235h.312v.153Z",
    transform: "translate(20.995 14.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6955",
    "data-name": "Caminho 6955",
    d: "M29.752,20.56l-.089-.293-.144.045Z",
    transform: "translate(21.092 14.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6956",
    "data-name": "Caminho 6956",
    d: "M29.757,20.566l-.245-.183.1-.125Z",
    transform: "translate(21.087 14.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6957",
    "data-name": "Caminho 6957",
    d: "M29.449,20.566l.245-.183-.089-.125Z",
    transform: "translate(21.042 14.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6958",
    "data-name": "Caminho 6958",
    d: "M29.449,20.56l.1-.293.144.045Z",
    transform: "translate(21.042 14.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6959",
    "data-name": "Caminho 6959",
    d: "M32.686,23.071l-.168.511.257.087Z",
    transform: "translate(23.235 16.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6960",
    "data-name": "Caminho 6960",
    d: "M32.655,23.071l.168.511-.264.087Z",
    transform: "translate(23.265 16.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6961",
    "data-name": "Caminho 6961",
    d: "M33.131,23.286H32.6v.276Z",
    transform: "translate(23.292 16.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6962",
    "data-name": "Caminho 6962",
    d: "M33.153,23.286l-.43.321-.156-.221Z",
    transform: "translate(23.27 16.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6963",
    "data-name": "Caminho 6963",
    d: "M32.319,23.286l.425.321.168-.221Z",
    transform: "translate(23.093 16.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6964",
    "data-name": "Caminho 6964",
    d: "M32.319,23.286h.533v.276Z",
    transform: "translate(23.093 16.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6965",
    "data-name": "Caminho 6965",
    d: "M32.971,23.852l-.168-.511-.25.086Z",
    transform: "translate(23.26 16.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6966",
    "data-name": "Caminho 6966",
    d: "M32.977,23.859l-.43-.314.154-.216Z",
    transform: "translate(23.255 16.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6967",
    "data-name": "Caminho 6967",
    d: "M32.43,23.859l.43-.314-.154-.216Z",
    transform: "translate(23.172 16.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6968",
    "data-name": "Caminho 6968",
    d: "M32.43,23.852l.161-.511.257.086Z",
    transform: "translate(23.172 16.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6969",
    "data-name": "Caminho 6969",
    d: "M33.418,22.363l-.132.408.2.069Z",
    transform: "translate(23.783 15.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6970",
    "data-name": "Caminho 6970",
    d: "M33.395,22.363l.132.408-.209.069Z",
    transform: "translate(23.806 15.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6971",
    "data-name": "Caminho 6971",
    d: "M33.779,22.537h-.43v.2Z",
    transform: "translate(23.829 16.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6972",
    "data-name": "Caminho 6972",
    d: "M33.8,22.537l-.341.245-.132-.168Z",
    transform: "translate(23.811 16.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6973",
    "data-name": "Caminho 6973",
    d: "M33.122,22.537l.348.245.13-.168Z",
    transform: "translate(23.666 16.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6974",
    "data-name": "Caminho 6974",
    d: "M33.122,22.537h.437v.2Z",
    transform: "translate(23.666 16.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6975",
    "data-name": "Caminho 6975",
    d: "M33.646,22.982l-.132-.406-.2.069Z",
    transform: "translate(23.806 16.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6976",
    "data-name": "Caminho 6976",
    d: "M33.651,22.99l-.341-.252.125-.173Z",
    transform: "translate(23.801 16.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6977",
    "data-name": "Caminho 6977",
    d: "M33.219,22.99l.341-.252-.132-.173Z",
    transform: "translate(23.736 16.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6978",
    "data-name": "Caminho 6978",
    d: "M33.219,22.982l.132-.406.2.069Z",
    transform: "translate(23.736 16.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6979",
    "data-name": "Caminho 6979",
    d: "M31.979,22.148l-.132.4.2.072Z",
    transform: "translate(22.756 15.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6980",
    "data-name": "Caminho 6980",
    d: "M31.951,22.148l.132.4-.2.072Z",
    transform: "translate(22.784 15.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6981",
    "data-name": "Caminho 6981",
    d: "M32.335,22.319H31.91v.218Z",
    transform: "translate(22.801 15.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6982",
    "data-name": "Caminho 6982",
    d: "M32.352,22.319l-.346.257-.12-.18Z",
    transform: "translate(22.783 15.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6983",
    "data-name": "Caminho 6983",
    d: "M31.683,22.319l.348.257.118-.18Z",
    transform: "translate(22.639 15.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6984",
    "data-name": "Caminho 6984",
    d: "M31.683,22.319h.437v.218Z",
    transform: "translate(22.639 15.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6985",
    "data-name": "Caminho 6985",
    d: "M32.213,22.77l-.132-.408-.209.07Z",
    transform: "translate(22.773 15.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6986",
    "data-name": "Caminho 6986",
    d: "M32.218,22.776l-.353-.252.132-.17Z",
    transform: "translate(22.768 15.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6987",
    "data-name": "Caminho 6987",
    d: "M31.774,22.776l.346-.252L32,22.354Z",
    transform: "translate(22.703 15.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6988",
    "data-name": "Caminho 6988",
    d: "M31.774,22.77l.132-.408.214.07Z",
    transform: "translate(22.703 15.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6989",
    "data-name": "Caminho 6989",
    d: "M26.562,21.76l-.192.607.3.1Z",
    transform: "translate(18.842 15.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6990",
    "data-name": "Caminho 6990",
    d: "M26.524,21.76l.2.607-.3.1Z",
    transform: "translate(18.88 15.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6991",
    "data-name": "Caminho 6991",
    d: "M27.114,22.022h-.646v.321Z",
    transform: "translate(18.912 15.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6992",
    "data-name": "Caminho 6992",
    d: "M27.142,22.022l-.533.374-.178-.261Z",
    transform: "translate(18.885 15.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6993",
    "data-name": "Caminho 6993",
    d: "M26.122,22.022l.538.374.173-.261Z",
    transform: "translate(18.665 15.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6994",
    "data-name": "Caminho 6994",
    d: "M26.122,22.022h.646v.321Z",
    transform: "translate(18.665 15.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6995",
    "data-name": "Caminho 6995",
    d: "M26.906,22.693l-.192-.607-.3.1Z",
    transform: "translate(18.875 15.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6996",
    "data-name": "Caminho 6996",
    d: "M26.916,22.705l-.514-.377.178-.261Z",
    transform: "translate(18.865 15.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6997",
    "data-name": "Caminho 6997",
    d: "M26.262,22.705l.521-.377-.192-.261Z",
    transform: "translate(18.765 15.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6998",
    "data-name": "Caminho 6998",
    d: "M26.262,22.693l.209-.607.3.1Z",
    transform: "translate(18.765 15.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6999",
    "data-name": "Caminho 6999",
    d: "M30.021,24.211l-.065.206.1.034Z",
    transform: "translate(21.404 17.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7000",
    "data-name": "Caminho 7000",
    d: "M30,24.211l.065.206-.089.034Z",
    transform: "translate(21.421 17.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7001",
    "data-name": "Caminho 7001",
    d: "M30.208,24.3h-.221v.1Z",
    transform: "translate(21.427 17.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7002",
    "data-name": "Caminho 7002",
    d: "M30.213,24.3l-.18.125-.053-.089Z",
    transform: "translate(21.422 17.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7003",
    "data-name": "Caminho 7003",
    d: "M29.875,24.3l.18.125.053-.089Z",
    transform: "translate(21.347 17.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7004",
    "data-name": "Caminho 7004",
    d: "M29.875,24.3h.209v.1Z",
    transform: "translate(21.347 17.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7005",
    "data-name": "Caminho 7005",
    d: "M30.129,24.523l-.053-.2-.1.036Z",
    transform: "translate(21.416 17.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7006",
    "data-name": "Caminho 7006",
    d: "M30.134,24.524l-.168-.123.055-.082Z",
    transform: "translate(21.411 17.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7007",
    "data-name": "Caminho 7007",
    d: "M29.921,24.524l.168-.123-.055-.082Z",
    transform: "translate(21.379 17.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7008",
    "data-name": "Caminho 7008",
    d: "M29.921,24.523l.072-.2.1.036Z",
    transform: "translate(21.379 17.377)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBra);
export default __webpack_public_path__ + "static/media/flag_BRA.e614470f77f6658281cd674a01c2347d.svg";
export { ForwardRef as ReactComponent };